import { GetCorporateCustomers } from "./getCorporateCustomers";
import { DEFAULT_PAGE } from "../../contstants";

const FilterCorporateCustomers = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const status = filters.status || "";
  const corporate_name = filters.s || "";

  return await GetCorporateCustomers({
    perPage,
    offset: (page - 1) * perPage,
    status,
    corporate_name,
  });
};

export default FilterCorporateCustomers;
